module.exports = __webpack_public_path__ + "img/before2.9aa7049e.png";